export default __webpack_public_path__ + "static/selectionImage-f8d44f0f39ad2d28b0c208814c542fe7.png";